<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Metodo de Pagamento</label>
          <v-select
            :value="metodoPaymentFilter"
            :options="metodoPaymentOptions"
            class="w-100"
            label="text"
            :reduce="val => val.value"
            @input="(val) => $emit('update:metodoPaymentFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            label="text"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>

        <!-- <b-col
            cols="12"
            md="4"
            class="mb-md-0 mb-2"
        >
          <label>Integração</label>
          <v-select
              :value="integracaoFilter"
              :options="integracaoOptions"
              class="w-100"
              label="text"
              :reduce="val => val.value"
              @input="(val) => $emit('update:integracaoFilter', val)"
          />
        </b-col> -->
      </b-row>
      <b-row class="mt-2">
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Data Início</label>
          <b-form-datepicker
            :value="dataInicioFilter"
            locale="pt-BR"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            placeholder="Selecione a data inicial"
            @input="handleDataInicioChange"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Data Fim</label>
          <b-form-datepicker
            :value="dataFimFilter"
            locale="pt-BR"
            :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
            placeholder="Selecione a data final"
            @input="handleDataFimChange"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormDatepicker,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormDatepicker,
    vSelect,
  },
  props: {
    metodoPaymentFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: '',
    },
    integracaoFilter: {
      type: [String, null],
      default: '',
    },
    dataInicioFilter: {
      type: [String, null],
      default: null,
    },
    dataFimFilter: {
      type: [String, null],
      default: null,
    },
    integracaoOptions: {
      type: Array,
      required: true,
    },
    metodoPaymentOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleDataInicioChange(val) {
      console.log('Data Início alterada:', val)
      this.$emit('update:dataInicioFilter', val)
    },
    handleDataFimChange(val) {
      console.log('Data Fim alterada:', val)
      this.$emit('update:dataFimFilter', val)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
